<template>
  <q-dialog
    :visible="isVisible"
    title="查看调整记录"
    width="1100px"
    :innerScroll="false"
    :showFooter="false"
    @close="onCancel"
  >
    <div class="dialog-content">
      <div class="record-header">
        <span class="headerText">产品编码：{{ row.productCode }}</span>
        <span class="headerText">产品名称：{{ row.productName }}</span>
      </div>
      <el-table border :data="tableData.list" height="200px" v-loading="loading" :header-cell-style="{ backgroundColor: '#F4F8FB' }">
        <el-table-column :show-overflow-tooltip="true" label="基础零售价" prop="retailPrice" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="A类价系数" prop="dailyRetailPrice" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="清仓销售价系数" prop="discountPriceClear" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="调整原因" prop="reason"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="更新人" prop="updatedBy" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="更新时间" prop="updatedDate" width="160"></el-table-column>
      </el-table>
      <div class="footerBox">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        ></el-pagination>
      </div>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'RetailPriceRecordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    fetchData() {
      this.loading = true;
      let data = {
        filterData: this.row.productCode,
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.product
        .adjustLog({ data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          } else {
            this.tableData.list = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.fetchData();
    },
  },
};
</script>

<style lang="stylus" scoped>
.dialog-content
  padding 0 15px 15px

.record-header
  padding-bottom 15px

.headerText
  display inline-block
  padding-right 50px

.footerBox
  text-align right
  padding-top 10px
</style>
